import React, { Component } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import ContactInfo from "./section-components/contact-info";
import ContactForm from "./section-components/contact-form";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { withAppData } from "../app/withAppData";
class ContactV1 extends Component {
  render() {
    const { contact, loading, lang, pageConfig } = this.props.appData;
    const contactConfig =
      pageConfig?.contact?.settings?.translations?.[lang] || {};
    const coverImg = pageConfig?.contact?.settings?.cover;
    return (
      <div>
        <Navbar />
        <PageHeader
          lang={lang}
          Img={coverImg}
          headertitle={contactConfig.title || "İletişim"}
          subheader={contactConfig.title || "İletişim"}
        />
        <ContactInfo
          contactPageConfig={contactConfig}
          contact={contact}
          loading={loading}
        />
        <ContactForm contactPageConfig={contactConfig} />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default withAppData(ContactV1);
